function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { guid } from '@bydesign-ui/utils';
export var FUNC_ID_KEY = guid();
export var NestWatcher = function () {
  function NestWatcher() {
    _classCallCheck(this, NestWatcher);

    this.watchers = [];
    this.waiting = [];
    this.watcherFuncMap = {};
    this.currentInDispatching = false;
    this.waitingChanges = [];
    this.waitingLazyChanges = [];
    this.dispatchingCount = 0;
    this.pendingKeyList = [];
  }

  _createClass(NestWatcher, [{
    key: "pendingKey",
    value: function pendingKey(key) {
      this.pendingKeyList.push(key);
    }
  }, {
    key: "finishKey",
    value: function finishKey(key) {
      var _this = this;

      var index = this.pendingKeyList.indexOf(key);

      if (index >= 0) {
        this.pendingKeyList.splice(index, 1);
        this.detectChangeList();
        this.waiting = this.waiting.filter(function (item) {
          if (_this.pendingKeyList.some(function (pending) {
            return NestWatcher.keyIsMatch(pending, item.key);
          })) {
            return true;
          }

          item.func();
          return false;
        });
      }
    }
  }, {
    key: "waitKey",
    value: function waitKey(creator, key, func) {
      this.waiting.push({
        creator: creator,
        func: func,
        key: key,
        keys: NestWatcher.splitKey(key)
      });
    }
  }, {
    key: "register",
    value: function register(creator, keys, func) {
      var _this2 = this;

      var lazy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var id = NestWatcher.getWatcherFuncId(func);

      if (!this.watcherFuncMap[id]) {
        this.watcherFuncMap[id] = {
          refs: 0,
          func: func
        };
      }

      keys.forEach(function (key) {
        _this2.watcherFuncMap[id].refs++;

        _this2.watchers.push({
          key: key,
          creator: creator,
          lazy: lazy,
          keys: NestWatcher.splitKey(key),
          guid: id
        });
      });
    }
  }, {
    key: "unregister",
    value: function unregister(creator, fn) {
      var watchers = this.watchers;

      for (var i = watchers.length - 1; i >= 0; i--) {
        var watcher = watchers[i];

        if (watcher.creator === creator && (fn == null || watcher.guid === NestWatcher.getWatcherFuncId(fn))) {
          watchers.splice(i, 1);

          if (--this.watcherFuncMap[watcher.guid].refs <= 0) {
            delete this.watcherFuncMap[watcher.guid];
          }
        }
      }
    }
  }, {
    key: "notify",
    value: function notify(keys) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.mergeWaitingInfo(keys.map(function (item) {
        return NestWatcher.splitKey(item);
      }), flags);
      this.detectChangeList();
    }
  }, {
    key: "mergeWaitingInfo",
    value: function mergeWaitingInfo(changedKeys, flags) {
      var _this3 = this;

      this.watchers.forEach(function (watcher) {
        var matchedKeys = changedKeys.filter(function (keys) {
          return NestWatcher.keysIsMatch(keys, watcher.keys);
        });

        if (!matchedKeys.length) {
          return;
        }

        var waitingList = watcher.lazy ? _this3.waitingLazyChanges : _this3.waitingChanges;
        var index = waitingList.findIndex(function (item) {
          return item.guid === watcher.guid;
        });
        var conf = index < 0 ? {
          changes: [],
          guid: watcher.guid,
          flags: {}
        } : waitingList[index];

        if (index < 0) {
          waitingList.push(conf);
        }

        NestWatcher.mergeFlags(conf.flags, flags);
        var child = matchedKeys.some(function (keys) {
          return keys.length > watcher.keys.length;
        });

        if (child) {
          conf.flags.child = true;
        }

        matchedKeys.map(function (keys) {
          var key = keys.join('.');

          if (conf.changes.indexOf(key) < 0) {
            conf.changes.push(key);
          }
        });
      });
    }
  }, {
    key: "processList",
    value: function processList(waiting) {
      var _this4 = this;

      waiting.forEach(function (item) {
        _this4.dispatchingCount++;
        var map = _this4.watcherFuncMap[item.guid];

        if (map == null) {
          return;
        }

        var res = map.func.call(null, item.changes, item.flags) || Promise.resolve();
        res.then(function () {
          _this4.dispatchingCount--;

          _this4.detectChangeList();
        }).catch(function (error) {
          console.error('promise error is not caught');
          console.error(error);
          _this4.dispatchingCount--;

          _this4.detectChangeList();
        });
      });
    }
  }, {
    key: "isWaiting",
    value: function isWaiting(info) {
      var _this5 = this;

      return info.changes.some(function (change) {
        return _this5.pendingKeyList.some(function (pending) {
          return NestWatcher.keyIsMatch(pending, change);
        });
      });
    }
  }, {
    key: "detectChangeList",
    value: function detectChangeList() {
      var _this6 = this;

      if (this.currentInDispatching) {
        return;
      }

      this.currentInDispatching = true;
      setTimeout(function () {
        _this6.currentInDispatching = false;

        var waitingChanges = _this6.pickValidChanges(_this6.waitingChanges);

        if (waitingChanges.length) {
          _this6.processList(waitingChanges);

          return;
        }

        if (_this6.dispatchingCount > 0) {
          return;
        }

        var waitingLazyChanges = _this6.pickValidChanges(_this6.waitingLazyChanges);

        if (waitingLazyChanges.length) {
          _this6.processList(waitingLazyChanges);
        }
      }, 0);
    }
  }, {
    key: "pickValidChanges",
    value: function pickValidChanges(list) {
      var picked = [];

      for (var i = list.length - 1; i >= 0; i--) {
        var change = list[i];

        if (!this.isWaiting(change)) {
          picked.push(change);
          list.splice(i, 1);
        }
      }

      return picked;
    }
  }], [{
    key: "combineKeys",
    value: function combineKeys(keys) {
      return keys.map(function (key) {
        var arr = [];
        var slash = false;

        for (var i = 0; i < key.length; i++) {
          var ch = key.charAt(i);

          if (!slash && ch === '.') {
            arr.push('\\');
          }

          arr.push(ch);
          slash = ch === '\\';
        }

        return arr.join('');
      }).join('.');
    }
  }, {
    key: "splitKey",
    value: function splitKey(key) {
      var res = [];
      var slash = false;
      var str = '';

      for (var i = 0; i < key.length; i++) {
        var ch = key.charAt(i);

        if (slash && ch === '.') {
          str = str.slice(0, -1) + '.';
        } else if (ch === '.') {
          res.push(str);
          str = '';
        } else {
          str += ch;
        }

        slash = ch === '\\';
      }

      if (str) {
        res.push(str);
      }

      return res;
    }
  }, {
    key: "keysIsMatch",
    value: function keysIsMatch(matchKeys, originKeys) {
      var i = 0;

      while (i < matchKeys.length && i < originKeys.length) {
        if (matchKeys[i] !== '*' && originKeys[i] !== '*' && originKeys[i] !== matchKeys[i]) {
          return false;
        }

        i++;
      }

      return true;
    }
  }, {
    key: "keyIsMatch",
    value: function keyIsMatch(matchKey, originKey) {
      return NestWatcher.keysIsMatch(NestWatcher.splitKey(matchKey), NestWatcher.splitKey(originKey));
    }
  }, {
    key: "mergeFlags",
    value: function mergeFlags(flagsOrigin, flagsMerge) {
      Object.keys(flagsMerge).forEach(function (key) {
        if (flagsMerge[key]) {
          flagsOrigin[key] = true;
        }
      });
    }
  }, {
    key: "getWatcherFuncId",
    value: function getWatcherFuncId(func) {
      var realFunc = func;

      if (realFunc[FUNC_ID_KEY]) {
        return realFunc[FUNC_ID_KEY];
      }

      var id = guid();
      Object.defineProperty(func, FUNC_ID_KEY, {
        enumerable: false,
        configurable: false,
        writable: false,
        value: id
      });
      return id;
    }
  }]);

  return NestWatcher;
}();